export const ADD_FILTER_OPTION = 'ADD_FILTER_OPTION';

export function addFilterOption(name, label, link, options){
	return { type: ADD_FILTER_OPTION, name, label, link, options }
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/actions/filter-options.js